import { useCallback, useEffect, useState } from 'react';

const usePixelRatio = () => {
  const [pixelRatio, setPixelRatio] = useState(window.devicePixelRatio);

  const updatePixelRatio = useCallback(() => {
    setPixelRatio(window.devicePixelRatio);
  }, []);

  const listenToChange = useCallback((media: MediaQueryList, callback: () => void) => {
    if (media.addEventListener) {
      media.addEventListener('change', callback);
      return () => {
        media.removeEventListener('change', callback);
      };
    }

    media.addListener(callback);
    return () => {
      media.removeListener(callback);
    };
  }, []);

  useEffect(() => {
    const media = window.matchMedia(`(resolution: ${pixelRatio}dppx)`);
    return listenToChange(media, updatePixelRatio);
  }, [listenToChange, pixelRatio, updatePixelRatio]);

  return pixelRatio;
};

export default usePixelRatio;
